import { authBeforeLoad, useRedirectToLoginIfNoAuth } from '@/lib/authGuard';
import { AppDevtools } from '@/components/appDevtools';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_plain')({
  component: RouteComponent,
  beforeLoad: authBeforeLoad,
});

function RouteComponent() {
  useRedirectToLoginIfNoAuth();

  return (
    <>
      <div className="p-10 min-h-screen overflow-hidden flex flex-col bg-fill-surface-strong">
        <Outlet />
      </div>
      <AppDevtools />
    </>
  );
}
